@if (!document) {
  <app-spinner></app-spinner>
} @else {
  <h1>
    @switch (documentType) {
      @case ('tos') {
        Terms of Use
      }
      @case ('privacy_policy') {
        TYT Privacy Policy
      }
      @case ('core_values') {
        TYT Core Values
      }
    }
  </h1>
  <p>Last updated: {{ document.published_at | date:'shortDate' }}</p>
  <div class="content cms-content" [innerHTML]="document.content | markdownToHtml: 'user' | trustHtml"></div>
}

<ng-template #content>
  <h1>
    @switch (documentType) {
      @case ('tos') {
        Terms of Use
      }
      @case ('privacy_policy') {
        TYT Privacy Policy
      }
      @case ('core_values') {
        TYT Core Values
      }
    }
  </h1>
  <p>Last updated: {{ document.published_at | date:'shortDate' }}</p>

  <div class="content cms-content" [innerHTML]="document.content | markdownToHtml | trustHtml"></div>
</ng-template>
